import React from "react";

const FormProgress = ({ steps, currentStep, completedFields, totalFields }) => {
  const percentage = totalFields > 0 ? Math.round((completedFields / totalFields) * 100) : 0;

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium" style={{ fontFamily: "var(--font-caption)", color: "var(--color-muted-foreground)" }}>
          Progreso del formulario
        </span>
        <span className="text-xs font-semibold" style={{ fontFamily: "var(--font-data)", color: "var(--color-primary)" }}>
          {percentage}%
        </span>
      </div>
      <div className="w-full h-2 rounded-full overflow-hidden" style={{ background: "var(--color-muted)" }}>
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${percentage}%`, background: "var(--color-primary)" }}
        />
      </div>
      <div className="flex gap-2 mt-3">
        {steps?.map((step, idx) => (
          <div key={idx} className="flex items-center gap-1">
            <div
              className="w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
              style={{
                background: step?.completed ? "var(--color-success)" : idx === currentStep ? "var(--color-primary)" : "var(--color-muted)",
                color: step?.completed || idx === currentStep ? "#fff" : "var(--color-muted-foreground)",
                fontFamily: "var(--font-data)",
              }}
            >
              {step?.completed ? "✓" : idx + 1}
            </div>
            <span className="text-xs hidden sm:block" style={{ fontFamily: "var(--font-caption)", color: idx === currentStep ? "var(--color-primary)" : "var(--color-muted-foreground)" }}>
              {step?.label}
            </span>
            {idx < steps?.length - 1 && (
              <div className="w-4 h-px mx-1 hidden sm:block" style={{ background: "var(--color-border)" }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FormProgress;